import { Branch } from '@/constants';

export const getBranchOptionsFrom = (data: Branch[]) => {
  return data.map((branch: Branch) => ({
    label: branch.branch,
    value: branch.branch
  }));
};
